"use strict";
import { initAfterInteract } from "../core";

// import Toast from 'bootstrap/js/dist/toast';
// import Alert from 'bootstrap/js/dist/alert';
// import Button from 'bootstrap/js/dist/button';
// import Carousel from 'bootstrap/js/dist/carousel'; // Use Swiper instead

export const initBootstrap = async (config = {}) => {
    const initializers = {
        initCollapse,
        initDropdown, // Uses popper.js
        initModal, // Likely loaded already if it was necessary
        initOffcanvas,
        initScrollSpy,
        initTab,
        initTooltip, // Uses popper.js
        initPopover, // Uses popper.js
    };
    const defaultLazy = Object.keys(initializers); // Start with all known initializers as lazy
    const critical = [];

    if (config.critical && Array.isArray(config.critical)) {
        config.critical.forEach((name) => {
            // Check if it's a valid initializer defined above
            if (initializers.hasOwnProperty(name)) {
                critical.push(name);
                // Remove from lazy list (if it's there)
                const index = defaultLazy.indexOf(name);
                if (index > -1) {
                    defaultLazy.splice(index, 1);
                }
            } else {
                console.warn(`initBootstrap: Config specified unknown critical initializer "${name}". Ignoring.`);
            }
        });
    }
    const lazy = defaultLazy;

    const criticalFuncs = critical
    .map(name => initializers[name]) // Get the actual function reference
    .filter(func => typeof func === 'function'); // Safety check

    if (criticalFuncs.length > 0) {
        // console.log(`initBootstrap: Running critical initializers: [${critical.join(', ')}]`);
        // Map to promises by calling the async functions
        // Use Promise.allSettled to run all even if some fail
        const criticalPromises = criticalFuncs.map(func => func());
        await Promise.allSettled(criticalPromises).then(results => {
             results.forEach((result, index) => {
                if (result.status === 'rejected') {
                    console.error(`Critical initializer ${criticalNames[index]} failed:`, result.reason);
                }
            });
        });
    }
    
    const lazyFuncs = lazy
    .map(name => {
        const func = initializers[name];
        return typeof func === 'function' ? () => func() : null;
    })
    .filter(Boolean); // Remove any null entries if a name wasn't found

    if (lazyFuncs.length > 0) {
        // console.log(`initBootstrap: Scheduling lazy initializers: [${lazy.join(', ')}]`);
        initAfterInteract(lazyFuncs); // Pass the array of functions to be called later
    }

    async function initCollapse() {
        const firstElement = document.querySelector('[data-bs-toggle="collapse"]');
        if (!firstElement) return;

        try {
            import('bootstrap/js/dist/collapse');
        } catch (error) {
            console.error("Failed to load Collapse dynamically:", error);
        }
    }

    async function initDropdown() {
        const firstElement = document.querySelector('[data-bs-toggle="dropdown"]');
        if (!firstElement) return;

        try {
            import('bootstrap/js/dist/dropdown');
        } catch (error) {
            console.error("Failed to load Dropdown dynamically:", error);
        }
    }

    async function initModal() {
        const firstElement = document.querySelector('[data-bs-toggle="modal"]');
        if (!firstElement) return;

        try {
            import('bootstrap/js/dist/modal');
        } catch (error) {
            console.error("Failed to load Modal dynamically:", error);
        }
    }

    async function initOffcanvas() {
        const firstElement = document.querySelector('[data-bs-toggle="offcanvas"]');
        if (!firstElement) return;

        try {
            import('bootstrap/js/dist/offcanvas');
        } catch (error) {
            console.error("Failed to load Offcanvas dynamically:", error);
        }
    }

    async function initScrollSpy() {
        const firstElement = document.querySelector('[data-bs-spy="scroll"]');
        if (!firstElement) return;

        try {
            import('bootstrap/js/dist/scrollspy');
        } catch (error) {
            console.error("Failed to load ScrollSpy dynamically:", error);
        }
    }

    async function initTab() {
        const firstElement = document.querySelector('[data-bs-toggle="tab"]');
        if (!firstElement) return;

        try {
            import('bootstrap/js/dist/tab');
        } catch (error) {
            console.error("Failed to load Tab dynamically:", error);
        }
    }

    async function initTooltip() {
        const elements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        if (!elements.length) return;

        try {
            const module = await import('bootstrap/js/dist/tooltip');
            let Tooltip = module.default;
            elements.forEach((element) => {
                new Tooltip(element);
            });
        } catch (error) {
            console.error("Failed to load Tooltip dynamically:", error);
        }
    }

    async function initPopover() {
        const elements = document.querySelectorAll('[data-bs-toggle="popover"]');
        if (!elements.length) return;

        try {
            const module = await import('bootstrap/js/dist/popover');
            let Popover = module.default;
            elements.forEach((element) => {
                new Popover(element);
            });
        } catch (error) {
            console.error("Failed to load Popover dynamically:", error);
        }
    }

}